import React from 'react';
import { GetStaticProps } from 'next';
import { bffService } from '@thisisdevelopment/akzonobel-core';
import {
  CmsSections,
  CmsSectionType,
  CmsVideo,
  FooterBlocks,
  Page,
} from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { pageRevalidate } from '../../src/config';

type ForProfessionalsType = {
  title: string;
  headline: string;
  video_cover: number;
  video: number;
  sections: CmsSectionType[];
};

type SSRProps = {
  page: ForProfessionalsType;
};

function ForProfessionals({ page }: SSRProps) {
  const meta = metas.default;
  return (
    <div>
      <NextHead meta={meta} />
      <Page title={page.title} headline={page.headline}>
        <CmsSections sections={page.sections} />
        <CmsVideo coverId={page.video_cover} videoId={page.video} mt="50px" />
        <FooterBlocks page="for-professionals" my="40px" />
      </Page>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const page = await bffService.getCmsItem('for_professionals').then((res) => res.data.data[0]);
  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export default ForProfessionals;
